import React from "react";

import { arrayToIndexedObject } from "@/utils/arrayUtil";
import { BehavioralGoalsRating } from "@/features/notes/(v2)/components/BehavioralGoalsRating";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { RATING_OPTION_LABEL_MAP, SCREENING_OPTION_LABEL_MAP } from "@/constants/rating";

export function IndividualSymptomTrend(props) {
  const { answer } = props;
  let labelOptions;

  if (answer.rating_labels) {
    labelOptions = arrayToIndexedObject(answer.rating_labels);
  } else {
    labelOptions =
      answer.type == null || answer.type === "rating"
        ? RATING_OPTION_LABEL_MAP
        : SCREENING_OPTION_LABEL_MAP;
  }

  return (
    <CardSecondary className="m-3 p-3 grey-container">
      <p className="fs-12 tw:font-bold">{answer.label}</p>
      <div className="d-flex justify-content-start">
        {Object.values(labelOptions).map((optionLabel, index) => (
          <div className="w-25 fs-10 text-center tw:font-bold" key={optionLabel + index}>
            <div className="m-auto">{optionLabel}</div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-start">
        <BehavioralGoalsRating
          containerClass="p-0"
          isEditing={false}
          optionLabelMap={labelOptions}
          progress={answer}
        />
      </div>
    </CardSecondary>
  );
}
